import React from 'react';

function AvatarList({ avatars, maxShow = 4, width = 50, height = 50 }) {
  const more = avatars.length > maxShow ? avatars.length - maxShow : 0

  return (
    <div className='avatar-list-container'>
      <div className='list-avatar' style={{ display: 'flex', flexWrap: 'wrap' }}>
        {avatars.map((avatar, index) => {
          if (index < maxShow) {
            return (
              <div className='avatar-show' key={index} style={{ width, height }}>
                <img className='avatar' src={avatar} alt="" />
              </div>
            );
          } else if (index === maxShow) {
            return (
              <React.Fragment key={index}>
                <div className='avatar-hidden' style={{ width, height }}>
                  <div className='more-text'>{`+ ${more}`}</div>
                </div>
              </React.Fragment>
            );
          }
        })}
      </div>
    </div>
  );
}

export default AvatarList;